<script setup>
import { computed } from 'vue';
import { cn } from '@/lib/utils';

const props = defineProps({
  product: Object,
  selectedScene: Object,
});

const emit = defineEmits(['click']);

// 图标映射：product.name -> 图标文件名
const iconMap = {
  'scrollytelling-generator': 'longPost.svg',
  'poster-generator': 'Poster.svg',
  'social-media-generator': 'SocialMedia.svg',
  'presentation-generator': 'PPT.svg',
  'multi-page-brochure-generator': 'Brochures.svg',
  'diagram-generator': 'Flow.svg',
  'ai-pull-up-banner-generator': 'Pull-Up-Banner.svg',
  'ai-flyer-generator': 'Flyer.svg',
  'menu-generator': 'Menu.svg',
  'music-album-generator': 'Album.svg',
  'infographic-generator': 'Knowledgecard.svg',
  'wechat-cover-generator': 'wechat.svg',
  'invitation-generator': 'invite.svg',
  'signage-generator': 'Singal.svg',
};

const iconUrl = computed(() => {
  const iconFile = iconMap[props.product?.name];
  return iconFile ? `/images/scene/${iconFile}` : null;
});

function onClick(product) {
  emit('click', product);
}
</script>
<template>
  <div
    :data-product="product.name"
    :class="
      cn(
        'group relative min-w-[9rem] flex-shrink-0 flex flex-col items-center gap-3 p-3 cursor-pointer rounded-[24px] transition-all duration-300 ease-out',
        selectedScene.name === product.name ? 'bg-white/60' : ''
      )
    "
    @click="onClick(product)"
  >
    <!-- Badge Container -->
    <div class="absolute -top-2 -right-2 z-10">
      <div
        v-if="product.isNew"
        class="bg-gradient-to-r from-rose-400 to-pink-400 text-white text-[9px] px-2 py-1 rounded-full font-semibold shadow-lg tracking-wide uppercase"
      >
        NEW
      </div>
    </div>

    <!-- Icon Container - 32px × 32px -->
    <div class="w-8 h-8 flex items-center justify-center">
      <img
        v-if="iconUrl"
        :src="iconUrl"
        :alt="product.nameText || product.name"
        class="w-full h-full object-contain"
      />
      <div v-else-if="product.icon" v-html="product.icon" class="w-full h-full text-black/60"></div>
    </div>

    <!-- Text Container -->
    <div
      :class="[
        'text-[13px] leading-tight font-normal text-center transition-all duration-300',
        selectedScene.name === product.name ? 'text-black' : 'text-black/50 group-hover:text-black',
      ]"
    >
      <template v-if="product.language">
        {{ $t('title', '', product.language) }}
      </template>
      <template v-else>
        {{ $t(product.nameText) }}
      </template>
    </div>
  </div>
</template>
